/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './ngx-gallery-image.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from './ngx-gallery-arrows.component.ngfactory';
import * as i4 from 'ngx-gallery/lib/ngx-gallery-arrows.component';
import * as i5 from 'ngx-gallery/lib/ngx-gallery-image.component';
import * as i6 from 'ngx-gallery/lib/ngx-gallery-helper.service';
const styles_NgxGalleryImageComponent:any[] = [i0.styles];
export const RenderType_NgxGalleryImageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NgxGalleryImageComponent,data:{}});
function View_NgxGalleryImageComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'div',[['class',
      'ngx-gallery-image']],[[4,'background-image',(null as any)]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.handleClick($event,_v.context.index)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i1.ɵpod({'ngx-gallery-active':0,'ngx-gallery-inactive-left':1,
      'ngx-gallery-inactive-right':2,'ngx-gallery-clickable':3})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'ngx-gallery-image';
    const currVal_2:any = _ck(_v,2,0,(_co.selectedIndex == _v.context.index),(_co.selectedIndex > _v.context.index),
        (_co.selectedIndex < _v.context.index),_co.clickable);
    _ck(_v,1,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = (('url(' + _v.context.$implicit) + ')');
    _ck(_v,0,0,currVal_0);
  });
}
function View_NgxGalleryImageComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-arrows',
      ([] as any[]),[[8,'className',0]],[[(null as any),'onPrevClick'],[(null as any),
          'onNextClick']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('onPrevClick' === en)) {
          const pd_0:any = ((<any>_co.showPrev()) !== false);
          ad = (pd_0 && ad);
        }
        if (('onNextClick' === en)) {
          const pd_1:any = ((<any>_co.showNext()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i3.View_NgxGalleryArrowsComponent_0,i3.RenderType_NgxGalleryArrowsComponent)),
      i1.ɵdid(49152,(null as any),0,i4.NgxGalleryArrowsComponent,([] as any[]),{prevDisabled:[0,
          'prevDisabled'],nextDisabled:[1,'nextDisabled'],arrowPrevIcon:[2,'arrowPrevIcon'],
          arrowNextIcon:[3,'arrowNextIcon']},{onPrevClick:'onPrevClick',onNextClick:'onNextClick'})],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:boolean = !_co.canShowPrev();
        const currVal_2:boolean = !_co.canShowNext();
        const currVal_3:any = _co.arrowPrevIcon;
        const currVal_4:any = _co.arrowNextIcon;
        _ck(_v,1,0,currVal_1,currVal_2,currVal_3,currVal_4);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i1.ɵinlineInterpolate(1,'ngx-gallery-image-size-',_co.size,
            '');
        _ck(_v,0,0,currVal_0);
      });
}
export function View_NgxGalleryImageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NgxGalleryImageComponent_1)),i1.ɵdid(802816,
          (null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n'])),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NgxGalleryImageComponent_2)),i1.ɵdid(16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i5.NgxGalleryImageComponent = _v.component;
    const currVal_1:any = _co.images;
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = _co.arrows;
    _ck(_v,7,0,currVal_2);
  },(_ck,_v) => {
    var _co:i5.NgxGalleryImageComponent = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(2,'ngx-gallery-image-wrapper ngx-gallery-animation-',
        _co.animation,' ngx-gallery-image-size-',_co.size,'');
    _ck(_v,0,0,currVal_0);
  });
}
export function View_NgxGalleryImageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-image',
      ([] as any[]),(null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onMouseEnter()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).onMouseLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },View_NgxGalleryImageComponent_0,RenderType_NgxGalleryImageComponent)),i1.ɵdid(638976,
      (null as any),0,i5.NgxGalleryImageComponent,[i1.ElementRef,i6.NgxGalleryHelperService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NgxGalleryImageComponentNgFactory:i1.ComponentFactory<i5.NgxGalleryImageComponent> = i1.ɵccf('ngx-gallery-image',
    i5.NgxGalleryImageComponent,View_NgxGalleryImageComponent_Host_0,{images:'images',
        clickable:'clickable',selectedIndex:'selectedIndex',arrows:'arrows',arrowsAutoHide:'arrowsAutoHide',
        swipe:'swipe',animation:'animation',size:'size',arrowPrevIcon:'arrowPrevIcon',
        arrowNextIcon:'arrowNextIcon'},{onClick:'onClick',onActiveChange:'onActiveChange'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvbmd4LWdhbGxlcnkvbGliL25neC1nYWxsZXJ5LWltYWdlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL25neC1nYWxsZXJ5L2xpYi9uZ3gtZ2FsbGVyeS1pbWFnZS5jb21wb25lbnQudHMiLCJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL25neC1nYWxsZXJ5L2xpYi9uZ3gtZ2FsbGVyeS1pbWFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvbmd4LWdhbGxlcnkvbGliL25neC1nYWxsZXJ5LWltYWdlLmNvbXBvbmVudC50cy5OZ3hHYWxsZXJ5SW1hZ2VDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwibmd4LWdhbGxlcnktaW1hZ2Utd3JhcHBlciBuZ3gtZ2FsbGVyeS1hbmltYXRpb24te3thbmltYXRpb259fSBuZ3gtZ2FsbGVyeS1pbWFnZS1zaXplLXt7c2l6ZX19XCI+XG4gICAgPGRpdiBjbGFzcz1cIm5neC1nYWxsZXJ5LWltYWdlXCIgKm5nRm9yPVwibGV0IGltYWdlIG9mIGltYWdlczsgbGV0IGkgPSBpbmRleFwiIFtuZ0NsYXNzXT1cInsgJ25neC1nYWxsZXJ5LWFjdGl2ZSc6IHNlbGVjdGVkSW5kZXggPT0gaSwgJ25neC1nYWxsZXJ5LWluYWN0aXZlLWxlZnQnOiBzZWxlY3RlZEluZGV4ID4gaSwgJ25neC1nYWxsZXJ5LWluYWN0aXZlLXJpZ2h0Jzogc2VsZWN0ZWRJbmRleCA8IGksICduZ3gtZ2FsbGVyeS1jbGlja2FibGUnOiBjbGlja2FibGUgfVwiIFtzdHlsZS5iYWNrZ3JvdW5kLWltYWdlXT1cIid1cmwoJyArIGltYWdlICsgJyknXCIgKGNsaWNrKT1cImhhbmRsZUNsaWNrKCRldmVudCwgaSlcIj48L2Rpdj5cbjwvZGl2PlxuPG5neC1nYWxsZXJ5LWFycm93cyBjbGFzcz1cIm5neC1nYWxsZXJ5LWltYWdlLXNpemUte3tzaXplfX1cIiAqbmdJZj1cImFycm93c1wiIChvblByZXZDbGljayk9XCJzaG93UHJldigpXCIgKG9uTmV4dENsaWNrKT1cInNob3dOZXh0KClcIiBbcHJldkRpc2FibGVkXT1cIiFjYW5TaG93UHJldigpXCIgW25leHREaXNhYmxlZF09XCIhY2FuU2hvd05leHQoKVwiIFthcnJvd1ByZXZJY29uXT1cImFycm93UHJldkljb25cIiBbYXJyb3dOZXh0SWNvbl09XCJhcnJvd05leHRJY29uXCI+PC9uZ3gtZ2FsbGVyeS1hcnJvd3M+XG4iLCI8bmd4LWdhbGxlcnktaW1hZ2U+PC9uZ3gtZ2FsbGVyeS1pbWFnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0NJO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBeVQ7TUFBQTtNQUFBO0lBQUE7SUFBelQ7RUFBQSx1Q0FBQTtrREFBQTtNQUFBLGtDQUEyRTtNQUFBOztJQUF0RTtJQUFzRTtRQUFBO0lBQTNFLFdBQUssVUFBc0UsU0FBM0U7O0lBQXlRO0lBQXpRLFdBQXlRLFNBQXpROzs7O29CQUVKO01BQUE7VUFBQTtRQUFBO1FBQUE7UUFBMkU7VUFBQTtVQUFBO1FBQUE7UUFBMkI7VUFBQTtVQUFBO1FBQUE7UUFBdEc7TUFBQTthQUFBO1VBQUE7VUFBQTs7O1FBQWlJO1FBQWdDO1FBQWdDO1FBQWdDO1FBQWpPLFdBQWlJLFVBQWdDLFVBQWdDLFVBQWdDLFNBQWpPOzs7UUFBb0I7WUFBQTtRQUFwQixXQUFvQixTQUFwQjs7OztvQkFIQTtNQUFBO01BQTJHLDJDQUN2RztVQUFBLHVFQUFBO1VBQUE7VUFBQSx1Q0FBZ1c7TUFDOVYsdUNBQ047VUFBQSx1RUFBQTtVQUFBO1VBQUEsZUFBc1I7O0lBRm5QO0lBQS9CLFdBQStCLFNBQS9CO0lBRXdEO0lBQTVELFdBQTRELFNBQTVEOzs7SUFISztRQUFBO0lBQUwsV0FBSyxTQUFMOzs7O29CQ0FBO01BQUE7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsK0VBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/ngx-gallery/lib/ngx-gallery-image.component.ngfactory.ts